import script from "./TextOverflow.vue?vue&type=script&setup=true&lang=js"
export * from "./TextOverflow.vue?vue&type=script&setup=true&lang=js"

import "./TextOverflow.vue?vue&type=style&index=0&id=3b5c5d45&lang=scss"

export default script